// Skupinové produkty pro měsíční / roční data a jevy (/station-group/grp-*) — viz
// doc/plans/station-group-monthly-yearly-phenomena.md
//
// 1 chip = 1 slug v URL (/station-group/grp-mly-<key> | grp-yly-<key> | grp-jevy)
//   = 1 skupina tsId zobrazená v jedné buňce tabulky (stanice × čas).
//
// tsId odpovídají sloupcům, které u JEDNÉ stanice zobrazují MlyTeplotyView / MlySrazkyView /
// MlySvitView / MlyVitrView / MlyVlhkostView / YlyTeplotyView / YlyPrehledView / YlySrazkyView
// (viz ROW_GROUPS v těch komponentách). API: sdata_ts (stype=MONTH | YEAR), normály sndata_ts —
// stejné jako useMonthlyData / useYearlyData / useMonthlyNormals / useYearlyNormals.
//
// cols: 1–3 tsId; víc než 1 => každý časový sloupec se v gridu rozpadne na tolik podsloupců.
// normals: true => k dispozici normály (sndata_ts) => buňka ukazuje barevný diff proti normálu.

export const GROUP_MLY_PRODUCTS = [
  {
    key: 'teplota-prum', label: 'Prům. teplota', unit: '°C', decimals: 1, normals: true,
    cols: [{ tsId: 'TEMPAVG_AVG', label: 'Prům' }],
  },
  {
    key: 'teplota-min', label: 'Min. teplota', unit: '°C', decimals: 1, normals: true,
    cols: [{ tsId: 'TNMIN_AVG', label: 'Prům. min', normalMode: 'diff' }, { tsId: 'TNMIN_MIN', label: 'Abs. min' }],
  },
  {
    key: 'teplota-max', label: 'Max. teplota', unit: '°C', decimals: 1, normals: true,
    cols: [{ tsId: 'TXMAX_AVG', label: 'Prům. max', normalMode: 'diff' }, { tsId: 'TXMAX_MAX', label: 'Abs. max' }],
  },
  {
    key: 'letni-dny', label: 'Letní dny (Tmax ≥ 25 °C)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'TXMAX_GE25', label: 'dny' }],
  },
  {
    key: 'mrazove-dny', label: 'Mrazové dny (Tmin < 0 °C)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'TNMIN_L0', label: 'dny' }],
  },
  {
    key: 'ledove-dny', label: 'Ledové dny (Tmax < 0 °C)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'TXMAX_L0', label: 'dny' }],
  },
  {
    key: 'srazky', label: 'Srážkový úhrn', unit: 'mm', decimals: 1, normals: true, normalMode: 'pct',
    cols: [{ tsId: 'PRECIPSUM_SUM', label: 'Úhrn' }],
  },
  {
    key: 'srazkove-dny', label: 'Dny se srážkami (≥ 1 mm)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'PRECIPSUM_GE1', label: 'dny' }],
  },
  {
    key: 'snih', label: 'Sněhová pokrývka', unit: 'cm', decimals: 0, normals: false,
    cols: [{ tsId: 'SNOW_MAX', label: 'Max. výška' }, { tsId: 'SNOW_GE1', label: 'Dny ≥ 1 cm' }],
  },
  {
    key: 'svit', label: 'Sluneční svit', unit: 'hod', decimals: 1, normals: true, normalMode: 'pct',
    cols: [{ tsId: 'SUNSHINESUM_SUM', label: 'Úhrn' }],
  },
  {
    key: 'vitr', label: 'Rychlost větru', unit: 'm/s', decimals: 1, normals: true,
    cols: [{ tsId: 'WSAVG_AVG', label: 'Prům', normalMode: 'diff' }, { tsId: 'WSMAX_MAX', label: 'Max. náraz', normalMode: 'diff' }],
  },
  {
    key: 'tlak', label: 'Tlak vzduchu', unit: 'hPa', decimals: 1, normals: true,
    cols: [{ tsId: 'PRESSSEAAVG_AVG', label: 'Na hladině moře' }],
  },
  {
    key: 'vlhkost', label: 'Rel. vlhkost', unit: '%', decimals: 1, normals: true,
    cols: [{ tsId: 'HUMIDITYAVG_AVG', label: 'Prům' }],
  },
]

export const GROUP_YLY_PRODUCTS = [
  {
    key: 'teplota-prum', label: 'Prům. teplota', unit: '°C', decimals: 1, normals: true,
    cols: [{ tsId: 'TEMPAVG_AVG', label: 'Prům' }],
  },
  {
    key: 'teplota-extrem', label: 'Roční extrémy', unit: '°C', decimals: 1, normals: true,
    cols: [{ tsId: 'TNMIN_MIN', label: 'Abs. min', normalMode: 'diff' }, { tsId: 'TXMAX_MAX', label: 'Abs. max', normalMode: 'diff' }],
  },
  {
    key: 'letni-dny', label: 'Letní dny (Tmax ≥ 25 °C)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'TXMAX_GE25', label: 'dny' }],
  },
  {
    key: 'horke-dny', label: 'Horké dny (Tmax ≥ 30 °C)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'TXMAX_GE30', label: 'dny' }],
  },
  {
    key: 'mrazove-dny', label: 'Mrazové dny (Tmin < 0 °C)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'TNMIN_L0', label: 'dny' }],
  },
  {
    key: 'srazky', label: 'Roční úhrn srážek', unit: 'mm', decimals: 1, normals: true, normalMode: 'pct',
    cols: [{ tsId: 'PRECIPSUM_SUM', label: 'Úhrn' }],
  },
  {
    key: 'srazkove-dny', label: 'Dny se srážkami (≥ 0.1 mm)', unit: 'dny', decimals: 0, normals: true,
    cols: [{ tsId: 'PRECIPSUM_G0', label: 'dny' }],
  },
  {
    key: 'snih', label: 'Sněhová pokrývka', unit: 'cm', decimals: 0, normals: true,
    cols: [{ tsId: 'SNOW_MAX', label: 'Max. výška' }, { tsId: 'SNOW_GE1', label: 'Dny ≥ 1 cm', normalMode: 'diff' }],
  },
  {
    key: 'svit', label: 'Roční svit', unit: 'hod', decimals: 1, normals: true, normalMode: 'pct',
    cols: [{ tsId: 'SUNSHINESUM_SUM', label: 'Úhrn' }],
  },
  {
    key: 'vitr', label: 'Rychlost větru', unit: 'm/s', decimals: 1, normals: true,
    cols: [{ tsId: 'WSAVG_AVG', label: 'Prům', normalMode: 'diff' }, { tsId: 'WSMAX_MAX', label: 'Max. náraz', normalMode: 'diff' }],
  },
]

// Menu produktu ve StationGroupLayout je od doc/plans/product-registry-refactor.md (etapa 1)
// odvozeno z centrálního registru — viz GROUP_PRODUCTS v src/config/productRegistry.js.

export const GROUP_MLY_BY_SLUG = new Map(GROUP_MLY_PRODUCTS.map(p => [`grp-mly-${p.key}`, p]))
export const GROUP_YLY_BY_SLUG = new Map(GROUP_YLY_PRODUCTS.map(p => [`grp-yly-${p.key}`, p]))

// Práh počtu stanic, nad který se místo rovnou tabulky ukáže potvrzovací shrnutí (obdoba gate
// v MeasGrafTable — u tabulky jde hlavně o počet HTTP požadavků na sdata_ts / phenomena_day).
export const GROUP_PERIOD_GATE_THRESHOLD = 40
